//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet } from '../../../../../axios/axios.js'
import BrigadeAutoAssignConfig from './BrigadeAutoAssignConfig.vue'

export default {
  components: {
    BrigadeAutoAssignConfig
  },
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      readonly: false, // TODO
      selectedTab: null,
      tabs: [
        'common',
        'urgent'
      ]
    }
  },
  computed: {
    ...mapGetters({
      requestTypes: 'getRequestTypes'
    }),
    autoAssignOnlyWithForkliftTruckLocal: {
      get: function () {
        return this.brigade.autoAssignOnlyWithForkliftTruck
      },
      set: function (value) {
        this.brigade.autoAssignOnlyWithForkliftTruck = value
      }
    }
  },
  watch: {
    selectedTab: function (value) {
      localStorage.setItem('brigadeAutoAssignSelectedTab', value)
    }
  },
  created: function () {
    const selectedTab = localStorage.getItem('brigadeAutoAssignSelectedTab')
    this.selectedTab = selectedTab !== null && this.tabs.includes(selectedTab) ? selectedTab : this.tabs[0]
  },
  methods: {
    getAvailableRequestTypes: function () {
      return this.requestTypes
    },
    getAvailableWorkTypes: function () {
      if (this.availableWorkTypes) {
        return this.availableWorkTypes
      } else {
        return this.loadAvailableWorkTypes()
      }
    },
    getAvailableWorkPackages: function () {
      if (this.availableWorkPackages) {
        return this.availableWorkPackages
      } else {
        return this.loadAvailableWorkPackages()
      }
    },
    loadAvailableWorkTypes: function () {
      return axiosGet({
        url: '/service/obj/search?type=workType&returnFields=id,name&start=0&limit=1000000',
        // url: '/service/obj/search?type=requestType&returnFields=id,name&start=0&limit=1000000',
        onSuccess: (response) => {
          this.availableWorkTypes = response.data.result
          return response.data.result
        },
        onFailure: 'Ошибка получения списка доступных для выбора работ',
        msgTarget: this
      })
    },
    loadAvailableWorkPackages: function () {
      return axiosGet({
        url: '/service/obj/search?type=workPackage&returnFields=id,name&add=workType&start=0&limit=1000000',
        onSuccess: (response) => {
          this.availableWorkPackages = response.data.result
          return response.data.result
        },
        onFailure: 'Ошибка получения списка доступных для выбора комплексов работ',
        msgTarget: this
      })
    }
  }
}

